<template>
  <mobile-multiselect
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template #default="slotProps">
      <mobile-multiselect-item-color
        v-for="option in slotProps.options"
        :key="option.id"
        :title="option.label"
        :is-selected="slotProps.isSelected(option)"
        :color="option.hex"
        @click.native="slotProps.toggle(option)"
      />
    </template>
  </mobile-multiselect>
</template>

<script>
import MobileMultiselect from '@/components/mobile-multiselect/mobile-multiselect.vue';
import MobileMultiselectItemColor from '@/components/mobile-multiselect/mobile-multiselect-item-color.vue';

export default {
  components: {
    MobileMultiselect,
    MobileMultiselectItemColor,
  }
}
</script>